import { Routes as Router, Route } from "react-router-dom";
import { PrivateRoute } from "./Route";
import { PermissionRoute } from "../components/PermissionRoute";
import { PERMISSOES } from "../hooks/usePermissions";
import { SignInOficiais } from "../pages/SignIn";
import DashboardLayout from "../components/DashboardLayout";
import { Dashboard } from "../pages/Dashboard";
import { AcessoNegado } from "../pages/AcessoNegado";
import { GestaoMilitares } from "../pages/Registros/GestaoMilitares";
import { Militares } from "../pages/Registros/Militares";
import { EditarMilitar } from "../pages/Registros/EditarMilitar";
import { Destaques } from "../pages/Registros/Destaques";
import { Treinamentos } from "../pages/Informacoes/Treinamentos";
import { Patrulhas } from "../pages/Informacoes/Patrulhas";
import Desempenho from "../pages/Informacoes/Desempenho";
import { Apostilas } from "../pages/Informacoes/Apostilas";
import { CategoriasApostilas } from "../pages/Informacoes/Apostilas/Categorias";
import { JustificativasAusencia } from "../pages/Informacoes/JustificativasAusencia";
import { RelatorioTreinamento } from "../pages/RelatorioTreinamento";
import { Central } from "../pages/Central";
import { MeuUsuario } from "../pages/MeuUsuario";
import { DiscordCallback } from "../pages/DiscordCallback";


import { Grupos } from "../pages/Configuracoes/Grupos";
import { GerenciarCargos } from "../pages/Configuracoes/GerenciarCargos";
import { GerenciarTiposAcoes } from "../pages/Configuracoes/GerenciarTiposAcoes";
import { GrupoPage } from "../pages/Grupos/GrupoPage";
import { GrupoTextoSitePage } from "../pages/Grupos/GrupoTextoSitePage";
import { CorrecaoProvaPage } from "../pages/Grupos/CorrecaoProvaPage";
import { Patentes } from "../pages/Configuracoes/Patentes";
import { Status } from "../pages/Configuracoes/Status";
import { Siglas } from "../pages/Configuracoes/Siglas";
import { Perfis } from "../pages/Configuracoes/Perfis";
import { Honrarias } from "../pages/Configuracoes/Honrarias";
import { GerenciarHonrarias } from "../pages/Configuracoes/GerenciarHonrarias";
import { GerenciarMedalhas } from "../pages/Configuracoes/GerenciarMedalhas";
import { GerenciarEmblemas } from "../pages/Configuracoes/GerenciarEmblemas";
import { Treinamentos as TreinamentosConfig } from "../pages/Configuracoes/Treinamentos";
import { Site } from "../pages/Configuracoes/Site";
import { Discord } from "../pages/Configuracoes/Discord";
import { WiredConfiguracoes } from "../pages/Configuracoes/Wired";
import { WiredLogs } from "../pages/Configuracoes/Wired/Logs";
import { Forum } from "../pages/Forum";
import { ForumPostView } from "../pages/Forum/ForumPostView";
import { Aniversariantes } from "../pages/Comunidade/Aniversariantes";
import { TiTiTinder } from "../pages/Comunidade/TiTiTinder";
import { TiTiTiPerolas } from "../pages/Comunidade/TiTiTiPerolas";
import { HorariosOficiais } from "../pages/Central/HorariosOficiais";
import { Loja } from "../pages/Loja";
import { Extrato } from "../pages/Loja/Extrato";
import { Logs } from "../pages/Logs";
import { ApostilasPainel } from "../pages/Apostilas";
import { Sobrevivente } from "../pages/Sobrevivente";

// Componente wrapper temporário para páginas não refatoradas
function LayoutWrapper({ children }: { children: React.ReactNode }) {
  return (
    <DashboardLayout>
      <div className="p-6">
        {children}
      </div>
    </DashboardLayout>
  );
}

export function Routes(): JSX.Element {
  return (
    <Router>
      <Route path="/" element={<SignInOficiais />} />
      <Route
        path="/acesso-negado"
        element={
          <DashboardLayout>
            <AcessoNegado />
          </DashboardLayout>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/registros/gestao-militares"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.CRIAR_ALTERAR_MILITAR}>
              <LayoutWrapper>
                <GestaoMilitares />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/registros/militares"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.LISTAR_MILITARES}>
              <LayoutWrapper>
                <Militares />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/registros/militares/:id/editar"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.EDITAR_MILITAR}>
              <LayoutWrapper>
                <EditarMilitar />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/registros/destaques"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_DESTAQUES}>
              <LayoutWrapper>
                <Destaques />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/informacoes/treinamentos"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <Treinamentos />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/informacoes/patrulhas"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <Patrulhas />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/informacoes/desempenho"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.VISUALIZAR_DESEMPENHO}>
              <LayoutWrapper>
                <Desempenho />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/informacoes/justificativas-ausencia"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <JustificativasAusencia />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/informacoes/apostilas"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_APOSTILAS}>
              <LayoutWrapper>
                <Apostilas />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/informacoes/apostilas/categorias"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_APOSTILAS}>
              <LayoutWrapper>
                <CategoriasApostilas />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/meu-usuario"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <MeuUsuario />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/discord/callback"
        element={
          <PrivateRoute>
            <DiscordCallback />
          </PrivateRoute>
        }
      />

      <Route
        path="/configuracoes/grupos"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.CRIAR_GRUPO}>
              <LayoutWrapper>
                <Grupos />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/grupos/:grupoId/cargos"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <GerenciarCargos />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/grupos/:grupoId/tipos-acoes"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <GerenciarTiposAcoes />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/grupos/:grupoNome"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <GrupoPage />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/grupos/:grupoNome/texto-site"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.EDITAR_GRUPO}>
              <LayoutWrapper>
                <GrupoTextoSitePage />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/grupos/provas/correcao/:id_acesso"
        element={
          <PrivateRoute>
            <CorrecaoProvaPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/patentes"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.CRIAR_PATENTE}>
              <LayoutWrapper>
                <Patentes />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/status"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.CRIAR_STATUS}>
              <LayoutWrapper>
                <Status />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/honrarias"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.LISTAR_HONRARIAS}>
              <LayoutWrapper>
                <Honrarias />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/gerenciar-honrarias"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_HONRARIAS}>
              <LayoutWrapper>
                <GerenciarHonrarias />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/gerenciar-medalhas"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_MEDALHAS}>
              <LayoutWrapper>
                <GerenciarMedalhas />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/gerenciar-emblemas"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_EMBLEMAS}>
              <LayoutWrapper>
                <GerenciarEmblemas />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/siglas"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.CRIAR_SIGLA}>
              <LayoutWrapper>
                <Siglas />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/perfis"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.CRIAR_PERFIL}>
              <LayoutWrapper>
                <Perfis />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracoes/treinamentos"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.CRIAR_ALTERAR_TREINAMENTO}>
              <LayoutWrapper>
                <TreinamentosConfig />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route path="/relatorio-treinamento" element={<RelatorioTreinamento />} />
      <Route
        path="/central"
        element={
          <PrivateRoute>
            <PermissionRoute anyPermission={[PERMISSOES.CENTRAL_RM_GERENCIAR, PERMISSOES.CENTRAL_RMO_GERENCIAR, PERMISSOES.CENTRAL_FILAS_GERENCIAR]}>
              <Central />
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/configuracoes/site"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_SITE_CARROSSEL}>
              <LayoutWrapper>
                <Site />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      {/* Rotas do Fórum */}
      <Route
        path="/forum"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.FORUM_VISUALIZAR}>
              <LayoutWrapper>
                <Forum />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/forum/:id"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.FORUM_VISUALIZAR}>
              <LayoutWrapper>
                <ForumPostView />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      {/* Rotas de Comunidade */}
      <Route
        path="/comunidade/aniversariantes"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.ANIVERSARIANTES_VISUALIZAR}>
              <LayoutWrapper>
                <Aniversariantes />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/comunidade/tititinder"
        element={
          <PrivateRoute>
            <PermissionRoute
              anyPermission={[PERMISSOES.TITITINDER_VISUALIZAR, PERMISSOES.TITITINDER_GERENCIAR]}
            >
              <LayoutWrapper>
                <TiTiTinder />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/comunidade/perolas"
        element={
          <PrivateRoute>
            <PermissionRoute
              anyPermission={[PERMISSOES.PEROLAS_ENVIAR, PERMISSOES.PEROLAS_GERENCIAR]}
            >
              <LayoutWrapper>
                <TiTiTiPerolas />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      {/* Horários de Oficiais */}
      <Route
        path="/central/horarios-oficiais"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.VISUALIZAR_HORARIOS_OFICIAIS}>
              <HorariosOficiais />
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/configuracoes/discord"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_INTEGRACOES_DISCORD}>
              <LayoutWrapper>
                <Discord />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/configuracoes/wired"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.GERENCIAR_WIRED_CONFIGURACOES}>
              <LayoutWrapper>
                <WiredConfiguracoes />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/configuracoes/wired/logs"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.VISUALIZAR_WIRED_LOGS}>
              <LayoutWrapper>
                <WiredLogs />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      {/* Sobrevivente: janela própria (sem barra do navegador), como a Central */}
      <Route
        path="/sobrevivente"
        element={
          <PrivateRoute>
            <Sobrevivente />
          </PrivateRoute>
        }
      />

      {/* Apostilas - acessível a todos os militares */}
      <Route
        path="/apostilas"
        element={
          <PrivateRoute>
            <ApostilasPainel />
          </PrivateRoute>
        }
      />

      {/* Audit Logs */}
      <Route
        path="/logs"
        element={
          <PrivateRoute>
            <PermissionRoute permission={PERMISSOES.VISUALIZAR_AUDIT_LOGS}>
              <LayoutWrapper>
                <Logs />
              </LayoutWrapper>
            </PermissionRoute>
          </PrivateRoute>
        }
      />

      {/* Loja de BRCoins */}
      <Route
        path="/loja"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <Loja />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
      <Route
        path="/loja/extrato"
        element={
          <PrivateRoute>
            <LayoutWrapper>
              <Extrato />
            </LayoutWrapper>
          </PrivateRoute>
        }
      />
    </Router>
  );
}
